import AxiosWrapper from "./AxiosWrapper"

export default class IDBAPI extends AxiosWrapper{
  protected static getApiUrl(){
    return process.env.REACT_APP_IDB2_API_URL
  }
}
